module.exports = __webpack_public_path__ + "static/media/programs.4b25c828.jpg";